<template>
  <b-form-group v-if="showComponent" :class="{ row : isOnModeLabelOnLeft }" :state="!v.$invalid">
    <label
      :for="idComputed"
      :title="titleComputed"
      :class=" {'col-sm-2': isOnModeLabelOnLeft, 'col-form-label': isOnModeLabelOnLeft }"
      class="text-truncate"
      v-if="label"
      >{{label}} <small v-if="required">*</small></label>
    <font-awesome-icon
      id="font-awesome-icon-edit"
      icon="edit"
      size="sm"
      class="clickable float-right mt-1"
      :class="{ 'ml-2': help }"
      v-if="showEditButton"
      @click="$emit('edit-button-clicked')"
      />
    <font-awesome-icon
      icon="question-circle"
      size="sm"
      class="clickable float-right mt-1"
      v-if="help"
      v-b-tooltip.hover="help"
    />
    <b-form-tags
      :input-id="idComputed"
      v-model="dataValue"
      separator=" ,;"
      :placeholder="placeholder"
      remove-on-delete
      :class="{'is-invalid': v.$invalid}"
      addButtonText="+"
      addButtonVariant="secondary"
    ></b-form-tags>
    <template #invalid-feedback>
      {{ validationsItemsMessage }}
      {{ validationsTagsMessage }}
    </template>
  </b-form-group>
</template>

<script>
// Utils
import _ from 'lodash'

// Mixins
import lmInputMixin from '@/mixins/lmInputMixin.js'

export default {
  mixins: [lmInputMixin],
  computed: {
    dataValue: {
      get () {
        return this.value || []
      },
      set (val) {
        this.$emit('input', val)
      }
    },
    validationsItemsMessage () {
      if (!this.dataValue.length || !Object.keys(this.v).length) return null
      const messages = []
      const emailError = _.findKey(this.v.$each, function (o) {
        return o && o.hasOwnProperty('email') && o.email === false
      })
      if (emailError) {
        messages.push('Las etiquetas deben ser un email válido.')
      }
      const minLengthError = _.findKey(this.v.$each, function (o) {
        return o && o.hasOwnProperty('minLength') && o.minLength === false
      })
      if (minLengthError) {
        messages.push(`Las etiquetas deben tener mínimo ${this.v.$each[minLengthError].$params.minLength.min} caracteres.`)
      }
      const maxLengthError = _.findKey(this.v.$each, function (o) {
        return o && o.hasOwnProperty('maxLength') && o.maxLength === false
      })
      if (maxLengthError) {
        messages.push(`Las etiquetas deben tener máximo ${this.v.$each[maxLengthError].$params.maxLength.max} caracteres.`)
      }
      const str = messages.join('. ')
      return str
    },
    validationsTagsMessage () {
      if (!this.dataValue.length || !Object.keys(this.v).length) return null
      let message = ''
      if (this.dataValue.length < this.minLengthCharactersRequired && this.minLengthCharactersRequired) {
        message = `Debes insertar al menos ${this.minLengthCharactersRequired} etiquetas.`
      }
      if (this.dataValue.length > this.maxLengthCharactersAllowed && this.maxLengthCharactersAllowed) {
        message = `Puedes insertar máximo ${this.maxLengthCharactersAllowed} etiquetas.`
      }
      return message
    }
  }
}
</script>
